const state = {
  localStore: true,
  addressBookStore: [],
  isMigrated: false
};

export default state;
